import React, {useEffect, useState, useRef, useCallback} from 'react';
import './control-panel.css'
import {auth, db} from "../../firebase/Firebase";
import {inject, observer} from "mobx-react";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import {useHistory} from "react-router-dom";
import HeaderControl from "./header-control/HeaderControl";
import SideBarDrawer from "./side-control/Drawer";
import SessionTimeout from "../home/main/session/SessionTimeout";
import MainControl from "./main-control/MainControl";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function ControlPanel(props) {

    const {DataStore, SessionStore} = props

    let history = useHistory();

    const classes = useStyles();

    const [company, setCompany] = useState(null)
    const [open, setOpen] = useState(true);

    const isMounted = useMountedState()

    useEffect(() => {

        const CompanyData = async () => {

            await auth.onAuthStateChanged(async authUser => {
                authUser
                    ? localStorage.setItem('authUser', JSON.stringify(authUser))
                    : localStorage.removeItem('authUser')


                if (authUser) {
                    await db.collection('Users').doc(authUser.uid).get()
                        .then((doc) => {
                            const dataUser = doc.data()

                            DataStore.getCompanyData(authUser.displayName, dataUser.idCompany, dataUser.role,
                                dataUser.companyMail, dataUser.userEmail, authUser.uid, dataUser.username)
                            DataStore.getImageAsUrl(authUser.photoURL)
                            DataStore.getUsersPermissions(dataUser.permits)
                        })
                    setOpen(false)
                    setCompany(true)

                } else {
                    history.push('/')
                }
            });
        }

        if (isMounted()) {
            CompanyData().catch(() => {
            })
        }
    }, [isMounted])

    useEffect(() => {
        window.onbeforeunload = function () {
            return true;
        };

        return () => {
            window.onbeforeunload = null;
        };
    }, []);

    return (
        <div>
            <SessionTimeout/>
            {company ?
                <div className={'control-panel-container'}>
                    <HeaderControl/>
                    <MainControl/>
                    <SideBarDrawer/>
                </div> :
                <div className="control-panel-load-image">
                    <Backdrop className={classes.backdrop} open={open}>
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </div>
            }
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default inject('DataStore', 'SessionStore')(observer(ControlPanel));